/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Task type

- essay: written response tasks
- activity: no written response required (e.g. collect material, perform external assignment)
- event: scheduled/meeting-like tasks with optional unlock conditions
- multiple_choice: MCQ quiz tasks with auto-grading
 */
export type TaskTypeEnum = (typeof TaskTypeEnum)[keyof typeof TaskTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskTypeEnum = {
  essay: 'essay',
  activity: 'activity',
  event: 'event',
  multiple_choice: 'multiple_choice',
  oral_exam: 'oral_exam',
} as const;
